import { SocialMediaTypeApiEnum } from '../../mediaSubscriptions/enums/media-subscription-media-type.enum';

interface SocialMediaTypeRequest {
    mediaType: SocialMediaTypeApiEnum;
    handles: string[];
}

export class SocialSearchRequestModel {
    mustAllTerms: string[];
    anyTerms: string[];
    mustNotTerms: string[];
    mediaTypeRequests: SocialMediaTypeRequest[];
}
